import { DivisionLookupDto } from './division-lookup.dto';

export class DivisionLookup {
    readonly id: string;
    readonly name: string;

    constructor(dto: DivisionLookupDto) {
        this.id = dto.id;
        this.name = dto.name;
    }
}
